import { ClientMessage } from '@common/api';

/**
 * Client-only service for server connection.
 * Holds the sendMessage callback set by main.ts after WebSocket connects.
 */
export class ConnectionService {
  /**
   * Function to send messages to the server.
   */
  public sendMessage: ((msg: ClientMessage) => void) | null = null;

  /**
   * Send a message to the server if connected.
   * @returns true if message was sent, false if not connected.
   */
  public send(msg: ClientMessage): boolean {
    if (this.sendMessage) {
      this.sendMessage(msg);
      return true;
    }
    return false;
  }

  /**
   * Reset the service (for testing).
   */
  public reset(): void {
    this.sendMessage = null;
  }
}
